import { useNavigate } from 'react-router-dom';
import { UploadDropZone } from '../components/UploadDropZone';

export function Upload() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-2 text-2xl font-semibold">Add a movie</h1>
      <p className="mb-6 text-sm text-text-secondary">
        Drop a video file. NNi Stream looks up the title on TMDb so it appears on your shelf
        with a poster while transcoding runs in the background.
      </p>
      <UploadDropZone
        onQueued={(mediaId) => {
          // Hop straight to the detail page so the user can watch the status
          // flip from `transcoding` → `ready` and play.
          navigate(`/movies/${mediaId}`);
        }}
      />
    </div>
  );
}
